export enum LoggedLinksEnum {
    solicitariUrbanismPlatform = 'dashboard/solicitari/institutie/urbanism',
    solicitariDgitlAccount = 'dashboard/solicitari/institutie/dgitl',
    solicitariAutorizariComerciale = 'dashboard/solicitari/institutie/autorizari-comerciale',
    programariAccount = 'dashboard/solicitari/programari-online',
    platiOnline = 'dashboard/payments',
    platiAlteTaxeAmenzi = 'dashboard/payments/selectare-plata',
    solicitariAsistentaSociala = 'dashboard/solicitari/institutie/asistenta-sociala',
}